import React from 'react'

import { theme } from '../../constants/ui/theme'

const Play = ({ background = theme.textHighlight, className }) => (
  <svg width="33" height="38" viewBox="0 0 33 38" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M32.1758 19.0743L0.30078 37.4774L0.300781 0.671299L32.1758 19.0743Z" fill={background} />
  </svg>
)

export default Play
